export * from './gray-box.component';
